import { Component } from '@angular/core';

@Component({
  selector: 'app-somesh-forge-pvt-ltd',
  templateUrl: './somesh-forge-pvt-ltd.component.html',
  styleUrls: ['./somesh-forge-pvt-ltd.component.scss']
})
export class SomeshForgePvtLtdComponent {

}
